import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaLayoutbancario', Service)

function Service($q, $filter, $export, $moment, NominasNomina, NominasNominaEmpleados, NominasNominaSuministro, NominasNominaBancos) {
  let NominasNominaLayoutbancario = this
  NominasNominaLayoutbancario.get = get
  NominasNominaLayoutbancario.bancomer = bancomer
  NominasNominaLayoutbancario.santander = santander

  function get(idEmpresa, idNomina) {
    return $q.all({
      nomina: NominasNomina.get(idEmpresa, idNomina),
      empleados: NominasNominaEmpleados.get(idEmpresa, idNomina),
      suministro: NominasNominaSuministro.get(idEmpresa, idNomina),
      bancos: NominasNominaBancos.get(idEmpresa, idNomina),
    }).then(function ($resolve) {
      let idMoneda = $resolve.nomina.ID_Moneda

      return $resolve.empleados.map(function (empleado, index) {
        let suministro = $resolve.suministro[index],
          bancos = $resolve.bancos[index],
          banco = bancos.Bancos[idMoneda == '1' ? 1 : 0] || {}

        return {
          ID_Empresa: empleado.ID_Empresa,
          ID_Empleado: empleado.ID_Empleado,
          Empleado: empleado.Empleado,
          Nombre: empleado.Nombre,
          Apellido_Paterno: empleado.Apellido_Paterno,
          Apellido_Materno: empleado.Apellido_Materno,
          Empresa: empleado.Empresa,
          Valido: banco.Cuenta.length <= 11,
          ID_Banco: banco.ID_Banco,
          Banco: banco.Banco,
          Cuenta: banco.Cuenta,
          Importe: suministro.Total - suministro.Deducciones.total(),
        }
      })
    })
  }

  function bancomer(data, filename) {
    let lPad = $filter('lPad'),
      rPad = $filter('rPad'),
      latinize = $filter('latinize')

    let layout = data.map(function (item, index) {
      return lPad(index + 1, 9, '0')
        + '                '
        + '99' + item.Cuenta
        + '          '
        + lPad(item.Importe.toFixed(2).replace(/\./g, ''), 15, '0')
        + latinize(rPad(item.Empleado, 40, ' '))
        + '001001'
    })

    layout.push('')

    return $export.textPlain(layout, filename)
  }

  function santander(data, filename, config) {
    let lPad = $filter('lPad'),
      rPad = $filter('rPad'),
      latinize = $filter('latinize'),
      sentido = 'E',
      codigo = '01',
      layout = [],
      total = 0

    layout.push('1' +
      lPad(layout.length + 1, 5, '0') +
      sentido +
      $moment().format('MMDDYYYY') +
      rPad(config.cuentaCargo, 16, ' ') +
      $moment(config.fechaPago).format('MMDDYYYY'),
    )

    data.forEach(function (item, index) {
      layout.push('2' +
        lPad(layout.length + 1, 5, '0') +
        rPad(index, 7, ' ') +
        latinize(rPad(item.Apellido_Paterno.substr(0, 30), 30, ' ').toUpperCase()) +
        latinize(rPad(item.Apellido_Materno.substr(0, 20), 20, ' ').toUpperCase()) +
        latinize(rPad(item.Nombre.substr(0, 30), 30, ' ').toUpperCase()) +
        rPad(item.Cuenta, 16, ' ') +
        lPad(item.Importe.toFixed(2).replace(/\./g, ''), 18, '0') +
        codigo,
      )
      total += item.Importe
    })

    layout.push('3' +
      lPad(layout.length + 1, 5, '0') +
      lPad(data.length, 5, '0') +
      lPad(total.toFixed(2).replace(/\./g, ''), 18, '0'),
    )

    layout.push('')

    return $export.textPlain(layout, filename)
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Layoutbancario.js